export class ConsentFormHandlerFactory {
    static instance;
    handler = null;
    static getInstance() {
        if (!ConsentFormHandlerFactory.instance) {
            ConsentFormHandlerFactory.instance = new ConsentFormHandlerFactory();
        }
        return ConsentFormHandlerFactory.instance;
    }
    registerHandler(handler) {
        this.handler = handler;
    }
    getHandler() {
        return this.handler;
    }
}
